import type { UnleashClient } from '@unleash/proxy-client-react';

import { sendGAEventToDataLayer } from '@nw/shared/utils';

/**
 * Pushes `unleash_impression` to the dataLayer using live assignment from Unleash.
 * Do not pass feature_name, variant, feature_enabled, event_type, or session_id in `extra`
 * unless intentionally overriding (extra is spread last).
 */
export const sendUnleashImpressionGaEvent = (
  client: UnleashClient,
  featureName: string,
  extra: Record<string, unknown> = {}
): void => {
  const variant = client.getVariant(featureName);
  const ctx = client.getContext();
  const sessionId = ctx.sessionId;

  sendGAEventToDataLayer({
    event: 'unleash_impression',
    feature_name: featureName,
    variant: variant.name,
    feature_enabled: variant.enabled,
    event_type: 'getVariant',
    ...(sessionId != null ? { session_id: sessionId } : {}),
    ...extra
  });
};
